import { secondAxios } from "../../../../../api/axios";

export const getPlantData = async (plantId) => {
  try {
    const res = await secondAxios.get(`/plant/${plantId}/mcs`);
    return res.data;
  } catch (err) {
    console.error("Error fetching plant data:", err);
    throw err;
  }
};
